import * as React from 'react';
import { SecondaryReportDataService, CharacteristicGroupDataService, SurveyReportTypeDataService } from '../../services';
import { CharacteristicGroup, SecondaryReport, SurveyReportType } from '../../models';
import { NavLink } from 'react-router-dom';
import { BaseRouteProps } from '../../interfaces';
import { SecondaryReportForm } from './SecondaryReportForm';
import { DataGridSimple, PVAPage } from '../../components';

interface SecondaryReportEditState {
    originalEntity: SecondaryReport | undefined;
    characteristicGroups: CharacteristicGroup[];
    surveyReportTypeID: number;
    reportTypes: SurveyReportType[];
}

export class SecondaryReportEdit extends React.Component<BaseRouteProps<{ id: number }>, SecondaryReportEditState> {
    private secondaryReportDataService = new SecondaryReportDataService(this.props.notificationService);
    private characteristicGroupDataService = new CharacteristicGroupDataService(this.props.notificationService);
    private surveyReportTypeDataService = new SurveyReportTypeDataService(this.props.notificationService);

    constructor(props: BaseRouteProps<{ id: number }>) {
        super(props);

        this.state = {
            originalEntity: undefined,
            characteristicGroups: [],
            surveyReportTypeID: -1,
            reportTypes: []
        };
    }

    public componentDidMount() {
        this.secondaryReportDataService.get(this.props.match.params.id)
            .then((secondaryReport: SecondaryReport) => {
                this.setState({
                    originalEntity: secondaryReport
                });
            
                this.surveyReportTypeDataService.getBySurveyVersion(secondaryReport.surveyVersionID).then((rts: SurveyReportType[]) => {
                    var rtID = -1;
                    if (rts.length > 0) {
                        rtID = rts[0].id;
                    }
                    this.setState({
                        reportTypes: rts,
                        surveyReportTypeID: rtID
                    });
                });

                this.characteristicGroupDataService.getAllByReport(secondaryReport)
                    .then((characteristicGroups: CharacteristicGroup[]) => {
                        this.setState({
                            characteristicGroups: characteristicGroups
                        });
                    });
            });
    }

    private deleteGroup(value: any) {
        if (confirm('Are you sure you want to delete this group?')) {
            var cgInd = this.state.characteristicGroups.findIndex((charGroup: CharacteristicGroup) => {
                return charGroup.id === value;
            });
            if (cgInd > -1) {
                this.characteristicGroupDataService.delete(this.state.characteristicGroups[cgInd]).then(() => {
                    var cgs = this.state.characteristicGroups;
                    cgs.splice(cgInd, 1);
                    this.setState({
                        characteristicGroups: cgs
                    });
                });
            }
        }
    }

    private CharacteristicGroupsDataGrid() {

        const listData = this.state.characteristicGroups.filter((cg: CharacteristicGroup) => {
            if (this.state.surveyReportTypeID === -1) {
                return true;
            }
            return cg.surveyReportTypeID === this.state.surveyReportTypeID;
        }).map(entity => {
            return {
                'Name': entity.name,
                'DeleteKey': entity.id,
                'ActionKey': entity.id
            };
        });

        const deleteColumn = ({ value }: any) => {
            return (
                <span>
                    <a className="btn btn-danger btn-block" onClick={(e: any) => this.deleteGroup(value)}>Delete</a>
                </span>
            );
        };

        const actionsColumn = ({ value }: any) => {
            return (
                <span>
                    <NavLink className="btn btn-default btn-block" to={`/characteristicgroup/${value}`}>View</NavLink>
                </span>
            );
        };

        const columnDefs = [
            { id: 'Name' },
            { id: 'DeleteKey', title: ' ', width: '88px', customComponent: deleteColumn, sortable: false },
            { id: 'ActionKey', title: 'Actions', width: '88px', customComponent: actionsColumn, sortable: false }
        ];

        return <DataGridSimple entities={listData} columns={columnDefs} pageSize={5} />;
    }
    
    private delete() {
        if (this.state.originalEntity && confirm('Are you sure you want to delete this secondary report?')) {
            var sv = this.state.originalEntity.surveyVersionID;
            this.secondaryReportDataService.delete(this.state.originalEntity).then(() => {
                this.props.history.push('/surveyversion/' + sv + '/secondaryreports');
            });
        }
    }

    public render() {
        if (this.state.originalEntity === undefined) {
            return <div />;
        }

        return (
            <PVAPage>
                <PVAPage.Header>
                    <PVAPage.Header.Buttons>
                        <NavLink to={'/surveyversion/' + this.state.originalEntity.surveyVersionID + '/secondaryreports'}>
                            <span className="glyphicon glyphicon-arrow-left" />
                        </NavLink>
                        <a className="btn btn-danger" onClick={(e: any) => this.delete()}>Delete</a>
                    </PVAPage.Header.Buttons>
                    <div className="title">Secondary Report Edit</div>
                </PVAPage.Header>

                <PVAPage.Body>
                    <SecondaryReportForm defaultValues={this.state.originalEntity} surveyVersionId={this.state.originalEntity.surveyVersionID} notificationService={this.props.notificationService} submit={(e: any) => this.save(e)} />
                
                    <hr />

                    <div className="row">
                        <div className="col-xs-8">
                            <h3>Characteristic Groups</h3>
                        </div>
                        <div className="col-xs-4 text-right">
                            <a className="btn btn-primary" onClick={(e) => this.createGroup()}>
                                Create <span className="glyphicon glyphicon-plus" />
                            </a>
                        </div>
                    </div>

                    <div>
                        <h5>Filter Report Type</h5>
                        <select className="form-control" value={this.state.surveyReportTypeID} onChange={(e) => this.setState({surveyReportTypeID: parseInt(e.target.value, 10)})}>
                            <option value={-1}>[No Filter]</option>;
                            {this.state.reportTypes.sort((rt1: SurveyReportType, rt2: SurveyReportType) => {
                                if (rt1.sort > rt2.sort) { return 1; }
                                if (rt1.sort < rt2.sort) { return -1; }
                                return 0;
                            }).map((rt: SurveyReportType) => {
                                return <option key={`rt-${rt.id}`} value={rt.id}>{rt.name}</option>;
                            })}
                        </select>
                    </div>
                    <i>These are the Characteristic Groups in this report.</i>
                    {this.CharacteristicGroupsDataGrid()}
                </PVAPage.Body>

                <PVAPage.Footer />
            </PVAPage>);
    }

    private save(values: any) {
        this.secondaryReportDataService.update(values);
    }

    private createGroup() {
        if (this.state.originalEntity) {
            var r = new CharacteristicGroup();
            r.secondaryReportID = this.state.originalEntity.id;
            r.surveyVersionID = this.state.originalEntity.surveyVersionID;
            this.characteristicGroupDataService.create(r).then((result: CharacteristicGroup) => {
                this.props.history.push(`/characteristicgroup/${result.id}`);
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/secondaryreport/SecondaryReportEdit.tsx